export enum AppRoutes {
  LOGOUT = 'logout',
  EMPLOYEES = 'employees',
  EMPLOYEES_DETAILS = 'employees-details',
  CREDIT_APPLICATIONS = 'credit-applications',
  CREDIT_APPLICATIONS_DETAILS = 'credit-applications-details',
  DOCUMENTS = 'documents',
  DOCUMENTS_DETAILS = 'documents-details',
  APPLICATION_CHECK = 'application-check',
  APPLICATION_CHECK_DETAILS = 'application-check-details',
  PRODUCTS = 'credit-products',
  CREDIT_PRODUCTS_DETAILS = 'credit-products-details',
  BANK_BRANCHES = 'bank-branches',
  BANK_BRANCHES_DETAILS = 'bank-branches-details',
  CREDIT_APPLICATIONS_CREATE = 'credit-applications-create',
  CREDIT_APPLICATIONS_CREATE_SMART = 'credit-applications-create-smart',
  MONITORING_LIST = 'monitoring-list',
  MONITORING_DETAILS = 'monitoring-details',
  MONITORING_CREATE = 'monitoring-create',
  MONITORING_UPDATE = 'monitoring-update',
  APPLICATION_CHECK_CREATE_STEP1 = 'application-check-form-1',
  APPLICATION_CHECK_CREATE_STEP2 = 'application-check-form-2',
  LAWYER_CONCLUSION = 'lawyer-conclusion',
  UNDERWRITER_CONCLUSION = 'underwriter-conclusion',
  LAWYER_CONCLUSION_PREVIEW = 'lawyer-conclusion-preview',
  UNDERWRITER_CONCLUSION_PREVIEW = 'underwriter-conclusion-preview',
  FARMER_CRITERIA = 'farmer-criteria',
  FARMER_CRITERIA_FORM = 'farmer-criteria-form',
  FARMER_CRITERIA_DETAILS = 'farmer-criteria-details',
}

export const getRouteLogin = () => '/';
export const getRouteForbidden = () => '/forbidden';

export const getAppsRoute = () => '/app';
export const getRouteICompanies = () => 'icompanies';
export const getRouteICompaniesDetails = (id: string) => `icompanies/${id}`;
export const getRouteEmployees = () => 'employees';
export const getRouteCreditApplications = () => 'credit-applications';
export const getRouteCreditApplicationsDetails = (id: string) =>
  `credit-applications/${id}`;
export const getRouteCreditApplicationsCreate = (id?: string) =>
  `credit-applications-create${id ? `/${id}` : ''}`;
export const getRouteCreditApplicationsCreateSmart = (id?: string) =>
  `credit-applications-create-smart${id ? `/${id}` : ''}`;
export const getRouteDocuments = () => 'documents';
export const getRouteDocumentsDetails = (uuid: string) => `documents/${uuid}`;
export const getRouteApplicationCheck = () => 'applications-check';
export const getRouteApplicationCheckDetails = (id: string) =>
  `applications-check/${id}`;
export const getRouteCreditProducts = () => 'credit-products';
export const getRouteCreditProductsDetails = (id: string) =>
  `credit-products/${id}`;
export const getRouteNotFound = () => 'not_found';
export const getRouteLogout = () => 'logout';
export const getRouteBankBranches = () => 'bank-branches';
export const getRouteBankBranchesDetails = (id: string) =>
  `bank-branches/${id}`;
export const getRouteEmployeesDetails = (id: string) => `employees/${id}`;
export const getRouteMonitoringList = () => 'monitoring-list';
export const getRouteMonitoringDetails = (id: string) =>
  `monitoring-list/${id}`;
export const getRouteMonitoringCreate = (id?: string) =>
  `monitoring-create${id ? `/${id}` : ''}`;
export const getRouteMonitoringUpdate = (id?: string) =>
  `monitoring-update${id ? `/${id}` : ''}`;
export const getRouteApplCheckCreateStep1 = () =>
  '/app/application-check-form-1';
export const getRouteApplCheckCreateStep2 = (id: string) =>
  `/app/application-check-form-2/${id}`;
export const getRouteConclusionForm = (id: string) =>
  `/app/lawyer-conclusion/${id}`;
export const getRouteUnderwriterConclusionForm = (id: string) =>
  `/app/underwriter-conclusion/${id}`;
export const getRouteLawyerConclusionPreview = (id: string) =>
  `/app/lawyer-preview/${id}`;
export const getRouteUnderwriterConclusionPreview = (id: string) =>
  `/app/underwriter-preview/${id}`;
export const getRouteFarmerCriteria = () => 'farmer-criteria';
export const getRouteFarmerCriteriaForm = (id?: string) =>
  `/app/farmer-criteria-form${id ? `/${id}` : ''}`;
export const getRouteFarmerCriteriaDetails = (id: string) =>
  `farmer-criteria/${id}`;
